import Image1 from "../../images/asserts/Website-Assets/About Us/image4.webp";
import Image2 from "../../images/asserts/Website-Assets/About Us/image3.webp";
import { useTranslation } from "react-i18next";

const AboutMission = () => {
  const { t }: { t: (key: string) => string } = useTranslation();

  return (
    <section className="relative bg-[#008847] py-16 border-t-4 border-gray-300">
      <div className="max-w-[94%] mx-auto">
        <div className="flex flex-col gap-16 text-white">
          {/* First Section */}
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6 md:gap-20">
            <h3 className="xl:text-5xl text-3xl w-full lg:max-w-[15%] uppercase text-center lg:text-left">
              {t('vision')}
            </h3>
            <div className="w-full">
              <p className="xl:text-[22px] text-sm leading-7 w-full lg:text-left">
                {t('vision2')}
              </p>
            </div>
            <div className="lg:w-[25%] w-full flex justify-center lg:justify-end">
              <img
                src={Image1}
                alt="mission1"
                className="w-full lg:w-full max-w-[800px] object-contain"
              />
            </div>
          </div>

          {/* Second Section */}
          <div className="border-t border-white pt-8">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-6 md:gap-20">
              <h3 className="xl:text-5xl text-3xl w-full lg:max-w-[15%] uppercase text-center lg:text-left">
                {t('vision3')}
              </h3>
              <div className="w-full">
                <p className="xl:text-[22px] text-sm leading-7 w-full lg:text-left">
                  {t('vision4')}
                </p>
              </div>
              <div className="lg:w-[25%] w-full flex justify-center lg:justify-end">
                <img
                  src={Image2}
                  alt="mission1"
                  className="w-full lg:w-full max-w-[800px] object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMission;
